// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"72":"1b9b9f9c","121":"6eccde35","153":"a104e722","597":"8687b79c","649":"f3fb2ad8","813":"746d2c29","897":"a11d92f1","978":"d5bb30e0"}[chunkId] + ".chunk.js";
};